export const search = {
    search: "Search",
    close: "Close",
    reset: "Reset",
    submit: "Search",
    level: "Grade",
    department: "Department",
    term: "Term",
    time: "Time",
    all: "All",
    type: "Groups",
    placeholder: "Enter keywords",
    empty: "Please select at least one search filter",
    departmentUnavailable: "The selected department cannot be searched right now.",
    timeFilterPlaceholder: "Drag on the timetable to select",
}
